import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-navy-900 text-slate-400 py-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 mb-8 pb-8 border-b border-white/5">
          <div>
            <span className="block font-extrabold text-2xl text-white tracking-tight mb-1">Local Trust & Visibility</span>
            <span className="block text-sm text-teal-500 font-bold uppercase tracking-wider mb-4">Comprehensive Audit</span>
            <p className="text-sm text-slate-500 max-w-sm">
              Helping local businesses fix their online trust gaps and dominate their markets in the AI search era.
            </p>
          </div>
          <div className="md:text-right">
            <ul className="space-y-3 text-sm font-medium">
              <li><a href="#problem" className="hover:text-teal transition-colors">The Problem</a></li>
              <li><a href="#deliverables" className="hover:text-teal transition-colors">What You Get</a></li>
              <li><a href="#process" className="hover:text-teal transition-colors">How It Works</a></li>
              <li><a href="#about" className="hover:text-teal transition-colors">About Chris Morris</a></li>
            </ul>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center text-xs font-medium text-slate-600">
          <p>&copy; {currentYear} Local Trust & Visibility Audit. All rights reserved.</p>
          <div className="mt-4 md:mt-0 space-x-4">
            <a href="#" className="hover:text-slate-400">Privacy Policy</a>
            <a href="#" className="hover:text-slate-400">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;